import { EventEmitter, Injectable, Output } from '@angular/core';
import { ApiService } from 'src/app/api/api.service';
import { Claim } from '../../models/buca/claim-model';
import { Policy } from '../../models/buca/policy';
import { Router } from '@angular/router';
import { Adjustment } from '../../models/buca/adjustment';
import { Dictum } from '../../models/buca/dictum';
import { AdditionalDocument } from '../../models/buca/additional-documentation';
import { CreateResponseIns } from '../../models/buca/crate-response-ins';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { MessageService } from 'primeng/api';
import { LoaderService } from 'src/app/api/loader.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MeService } from '../me.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClaimService {
  @Output() $shared_documents_specification: EventEmitter<any>  = new EventEmitter();
  // prueba
  @Output() $stage_claim_process: EventEmitter<any>  = new EventEmitter();
  @Output() $shared_adjustment_list: EventEmitter<any>  = new EventEmitter();
  @Output() $shared_dictum: EventEmitter<any> = new EventEmitter();
  @Output() $updateclaim: EventEmitter<any>  = new EventEmitter();
  @Output() $result: EventEmitter<any>  = new EventEmitter();
  @Output() $tooltip: EventEmitter<any>  = new EventEmitter();
  @Output() $new_call: EventEmitter<any>  = new EventEmitter();
  @Output() $adjustment_reset: EventEmitter<any>  = new EventEmitter();
  @Output() $update_current_process: EventEmitter<any>  = new EventEmitter();
  @Output() $add_subsecuent: EventEmitter<any>  = new EventEmitter();
  @Output() $add_teeth_procedure: EventEmitter<any> = new EventEmitter();

  shared_policy:Policy;
  shared_claim:Claim;
  shared_doc_catalog:number;
  shared_info:any;
  shared_list_info:any
  createInfoINS:any;
  document_specifications:any;
  count_required:number=0;
  adjustment_list:Adjustment[]=[]
  countConsults=0
  countPhisiotherapy=0
  loading = false
  total_presented = 0;
  total_deductible=0;
  total_coinsurance=0;
  total_not_authorized=0;
  dictum:Dictum[];
  additional:AdditionalDocument={};
  additional_document:AdditionalDocument[]=[];
  additional_document_list:any= [];
  additional_document_list_final:any= [];
  insNum:null;
  result:false;
  possible_claims:any;
  email=""
  createClaimIns:CreateResponseIns;
  accsa:any;
  tooltips:any;
  validations:any = [];
  validations_list:any=[];
  validation_list_client:any = [];
  client_count:number;
  campus_count:number;
  creation_blocked:boolean=false;
  totalCalls:any=[];
  phisioAdjust:Adjustment={}
  verifiedCounter:number;
  loadedCounter:number;
  rejectedCounter: number;
  requiredCounter:number;
  attendedCounter:number;
  spinnerLoad:number;
  spinnerVerify:number;
  dataSeat:any=[]
  bucaProcedures:any=[]
  bucaCategories:any=[]
  initialService: string = ""
  after_add_dictum_docs:boolean=false;
  medicalHistory = null;
  questionsMedicalHistory:any =null;
  dataSourcePatientHistory:any=[];
  planServiceData:any
  historyKidsAmount;
  historyHolderAndSpouseAmount;
  listProcedureHistory;
  
  
  sumAssured:number = 0;

  // Odontoprev
  senhaResponse

  // Currency_Exchange
  currency_exchange: any;


  _newPolicy:Policy = new Policy();
  _claim: Claim = new Claim();
  globalPreviewInfo:any;
  
  constructor(private api: ApiService,
    private _router: Router,
    public dialog:MatDialog,
    private me: MeService,
    private http: HttpClient,
    private loaderService: LoaderService,
    private messageService: MessageService) { }
  
  
  createPolicy(data,claim,user_id) {
    let global_info = {policy: data, claim:claim, user_id:parseInt(user_id)}
    
    this.api.policy.createPolicy(global_info).promise()
      .then(
          global_info => {
            this.shared_info = global_info
              
              
              this.messageService.add({
                severity: 'info',
                summary: 'Resultado',
                life: 4000,
                detail: "Evento creado con exito"
              });
              this.openClaim(global_info)
              this.setGlobalInfo(global_info);
              // this.setClaimInfo(global_info.claim);
              // this._router.navigate(['private/sinister-process'])
          }).catch( e=>{
              
              
              
              this.messageService.add({
                severity: 'error',
                summary: 'Resultado',
                life: 4000,
                detail: `Evento no fue creado. ${e.message.error}`
              });
          }
      );
    }

  openClaim(global_info) {
    
    this.setGlobalInfo(global_info);
    this._router.navigate(['private/home/sinister-process'])     
    }

  getPolicy(data){
    this.api.policy.getPolicyId(data).promise()
      .then(
          data => {
              
              

          }).catch( e=>{
              
              
              
          }
      );
  }

  createClaim(data) {
    this.api.claim.createClaim
    (data).promise()
      .then(
          data => {
              
              
          }).catch( e=>{
              
              
              
          }
      );
    }

  createClaimINS(data){
    this.api.ins.createClaimIns(data).promise()
    .then(
      data => {
        this.createClaimIns = data
        
        if(data.code!=200){
          this.messageService.add({
            severity: 'error',
            summary: 'Resultado',
            life: 4000,
            detail: data.code + " " + data.message
          });
        }
        else{
          this.messageService.add({
            severity: 'info',
            summary: 'Resultado',
            life: 4000,
            detail: "Reclamo creado con éxito"
          });
        }
        return data
      }).catch( e=>{
        
        
        
    }
    )
  }

  accsaVerification(data){
    this.api.ins.accsaVerification(data).promise()
    .then(
      data => {
        
        if(!data.ins_claim_number){
          this.messageService.add({
            severity: 'error',
            summary: 'Resultado',
            life: 4000,
            detail: "ACCSA no fue verificada: "+ data.message
          });
        }
        else{
          this.messageService.add({
            severity: 'info',
            summary: 'Resultado',
            life: 4000,
            detail: "ACCSA verificada con éxito"
          });
          this.accsa = data;
          
          this.insNum=data.ins_claim_number;
          let dictumId = this.shared_info.dictum[this.shared_info.dictum.length-1].dictumId
          let info={"dictumId":dictumId, "accsa":this.insNum}
          
          this.api.extra.addAccsaToDictum(info).promise()
          .then(
            data2 => {
              return data
            }).catch( e=>{
              
              
              
          }
          )

          return data
        }
      }).catch( e=>{
        
        
        
      }
    )
  }
  claimPaymentIns(data){
    
    this.api.ins.claimPaymentIns(data).promise()
    .then(
      data => {
        
        if(data.code == 200){
          this.messageService.add({
            severity: 'info',
            summary: 'Resultado',
            life: 4000,
            detail: "Pago procesado correctamente"
          });
        }
        else{
          this.messageService.add({
            severity: 'error',
            summary: 'Resultado',
            life: 4000,
            detail: "Pago no fue procesado correctamente"
          });
        }
      }).catch( e=>{
        
        
        
      }
    )
  }
  addBeneficiary(data){
    this.api.beneficiary.addBeneficiary(data).promise()
      .then(
          data => {
              
              this.messageService.add({
                severity: 'info',
                summary: 'Resultado',
                life: 4000,
                detail: "Beneficiario agregado"
              });
              
              let temp = this.getGlobalInfo()
              temp.beneficiary.push(data);
              this.setGlobalInfo(temp);
          }).catch( e=>{
              
              this.messageService.add({
                severity: 'error',
                summary: 'Resultado',
                life: 4000,
                detail: `Error al agregar beneficiario. ${e.message.error}`
              });
              
              
          }
      )}
  updateBeneficiary(data){
    let global = this.getGlobalInfo()
    const amount_claim:{} = global.coverage.amount
    
    let update ={
      ...data,
      amount_claim
    }
    
    this.api.beneficiary.updateBeneficiaryInfo(update).promise()
    .then(
      data => {
        
        
        this.shared_info.currentProcess = data
        
        this.$update_current_process.emit()
        this.messageService.add({
          severity: 'info',
          summary: 'Resultado',
          life: 4000,
          detail: "Tramite creado con éxito"
        });
      }
    ).catch(e =>{
      this.messageService.add({
        severity: 'error',
        summary: 'Resultado',
        life: 4000,
        detail: `Error al crear tramite. ${e.message.error}`
      });
      
    })
  }

  setDocumentsSpecfications(code, dialogRef?){
    this.additional_document_list = []
    
    
    
    if(dialogRef){
      
    }
    this.api.extra.getDocumentsSpecifications(code).promise()
    .then(
      data => {
        let additional
        
        
        this.countRequired(data)
        
        this.document_specifications = {"list":data, "count":this.count_required}
        
        
        
        if(this.dictum){
          for(let dict of this.dictum){
            if(dict.proceed==2){
              additional = true
              break
            }
            else{
              additional =false
            }
          }
        }
        if(this.dictum && this.dictum.length>=1 && additional){
          this.api.extra.getAdditionalDocuments(this.shared_info.currentProcess.current_processId).promise()
          .then(
            additionalData => {
              let add_quietus
              
              
              
              this.additional_document_list = additionalData
              // this.document_specifications.list = []
              for(let doc of additionalData){
                
                this.document_specifications.list.push(doc)
              }
              // prueba
              // this.additional_document_list=[]
              // if(this.shared_info.coverage.code == "0011"){
              //   this.additional_document_list=[]
              // }
              for(let dic of this.dictum){
                if(dic.proceed==1){
                  
                  add_quietus = true
                  break
                }
                else{
                  add_quietus = false
                }
              }
              
              for(let addDoc of this.document_specifications.list){
                if(addDoc.insured_document ==4 && addDoc.document_catalogId == 17){
                  this.additional_document_list.push(addDoc)
                }
                if(this.shared_info.coverage.code =="0011" && addDoc.document_catalogId ==17 && !add_quietus){
                  this.additional_document_list.pop()
                }
            
              }
              
              
              this.verifiedCounter = 0
              this.loadedCounter = 0
              this.rejectedCounter = 0
              this.requiredCounter = 0
              for(let doc of this.document_specifications.list){
                if((doc.required==1 && (doc.insured_document ==0 || doc.insured_document ==1)) || ( doc.insured_document == 4 &&  this.shared_info.stageClaim[this.shared_info.stageClaim.length-1].step == 4) || ( doc.insured_document == 4 &&  doc.document_catalogId>=18)|| ( doc.insured_document == 4 &&  this.dictum[this.dictum.length-1].proceed ==1)){
                  this.requiredCounter +=1
                  if(doc.document_statusId ==2 || doc.document_statusId ==3 || doc.document_statusId ==4){
                    this.loadedCounter +=1
                  }
                  if(doc.document_statusId==3 || doc.document_statusId == 4){
                    this.verifiedCounter += 1
                    if(doc.document_statusId == 4){
                      this.rejectedCounter +=1
                    }
                  }
                }
              }
              if(this.shared_info.coverage.code =="0011"){
                let reqcounter=this.requiredCounter 
                this.requiredCounter = reqcounter
                this.spinnerLoad = this.loadedCounter/(this.requiredCounter) * 100
                this.spinnerVerify = (this.verifiedCounter - this.rejectedCounter)/(this.requiredCounter ) * 100
              }
              else{
                this.spinnerLoad = this.loadedCounter/this.requiredCounter * 100
                this.spinnerVerify = (this.verifiedCounter - this.rejectedCounter)/this.requiredCounter * 100
              }
              
              
              
              
              
              
              
              this.$shared_documents_specification.emit(this.document_specifications);
              if(this.after_add_dictum_docs){
                
                // this.setDictumInfo(this.shared_info.currentProcess.current_processId)
                this.changeProcessDictum(this.dictum[this.dictum.length-1])
               //this.$shared_dictum.emit(this.dictum[this.dictum.length-1])
                this.after_add_dictum_docs=false
              }
              // else{
              //   this.$shared_dictum.emit(this.dictum[this.dictum.length-1])
              // }
            }).catch(e =>{
              this.messageService.add({
                severity: 'error',
                summary: 'Resultado',
                life: 4000,
                detail: `Error en la búsqueda de documentos adicionales. ${e.message.error}`
              });
              
            })
        }
        else{
          this.verifiedCounter = 0
          this.loadedCounter = 0
          this.rejectedCounter = 0
          this.requiredCounter = 0
            for(let doc of this.document_specifications.list){
              if( (doc.required==1 && (doc.insured_document ==0 || doc.insured_document ==1)) || ( doc.insured_document == 4 &&  this.shared_info.stageClaim[this.shared_info.stageClaim.length-1].step == 4)|| ( this.dictum.length >=1 && doc.insured_document == 4 &&  this.dictum[this.dictum.length-1].proceed == 1)||(doc.insured_document == 4 &&  this.shared_info.stageClaim[this.shared_info.stageClaim.length-1].step == 4)|| ( this.dictum.length >=1 && doc.insured_document == 4 &&  this.dictum[this.dictum.length-1].proceed == 1 && this.shared_info.coverage.code =="0011")){
                this.requiredCounter +=1
                
                if (( doc.insured_document == 4 &&  this.shared_info.stageClaim[this.shared_info.stageClaim.length-1].step == 4)|| ( this.dictum.length>=1 && doc.insured_document == 4 &&  this.dictum[this.dictum.length-1].proceed == 1)){
                  
                  this.additional_document_list.push(doc)
                  
                }
                if(doc.document_statusId ==2 || doc.document_statusId ==3 || doc.document_statusId ==4){
                  this.loadedCounter +=1
                }
                if(doc.document_statusId==3 || doc.document_statusId == 4){
                  this.verifiedCounter += 1
                  if(doc.document_statusId == 4){
                    this.rejectedCounter +=1
                  }
                }
              }
            }
            if(this.shared_info.coverage.code =="0011"){
              let reqcounter = this.requiredCounter
              this.requiredCounter = reqcounter
              this.spinnerLoad = this.loadedCounter/(this.requiredCounter) * 100
              this.spinnerVerify = (this.verifiedCounter - this.rejectedCounter)/(this.requiredCounter ) * 100
            }
            else{
              this.spinnerLoad = this.loadedCounter/this.requiredCounter * 100
              this.spinnerVerify = (this.verifiedCounter - this.rejectedCounter)/this.requiredCounter * 100
            }
            
            
            
            
            
            
            
            this.$shared_documents_specification.emit(this.document_specifications);
            if(this.after_add_dictum_docs){
              this.setDictumInfo(this.shared_info.currentProcess.current_processId)
              this.changeProcessDictum(this.dictum[this.dictum.length-1])
              // this.$shared_dictum.emit(this.dictum[this.dictum.length-1])
              this.after_add_dictum_docs=false
            }
        }
          if (dialogRef){
            dialogRef.close()
            this.messageService.add({
              severity: 'info',
              summary: 'Resultado',
              life: 4000,
              detail: "Se ha actualizado la información"
            });
        }
      }
    ).catch(e =>{
          this.messageService.add({
            severity: 'error',
            summary: 'Resultado',
            life: 4000,
            detail: `Error al avanzar al siguiente paso. ${e.message.error}`
          });
          
    })
    
  }

  changeProcessDictum(dictum){
    
    this.$shared_dictum.emit(dictum)
  }

  updateDocument(info, dialogRef?){
    this.api.extra.updateDocumentStatus(info).promise()
    .then(
      result => {
        
        
        let data = this.getGlobalInfo();
        let code = data.coverage.code
        let objectToUpdate ={
          code,
          ...result
        }
        
        
        
        if(dialogRef){
          
        }
        this.setDocumentsSpecfications(JSON.stringify(objectToUpdate), dialogRef)
      })
      .catch(e =>{
        this.messageService.add({
          severity: 'error',
          summary: 'Resultado',
          life: 4000,
          detail: `Error al actualizar el estado del documento. ${e.message.error}`
        });
        
      })
  }
  addValidation(validation){
    this.api.extra.addValidation(validation).promise()
    .then(
      result => {
        
        
      })
      .catch(e =>{
        this.messageService.add({
          severity: 'error',
          summary: 'Resultado',
          life: 4000,
          detail: `Error al agregar la validación. ${e.message.error}message.error}message.error}`
        });
        
      })
  }
  getValidations(documentationId){
    this.loaderService.display(true);
    this.validations=[]
    this.api.extra.getValidation(documentationId).promise()
    .then(
      result => {
        
        
        this.validations = result
        this.loaderService.display(false);
      })
      .catch(e =>{
        this.messageService.add({
          severity: 'error',
          summary: 'Resultado',
          life: 4000,
          detail: `Error al buscar la lista de validaciones. ${e.message.error}`
        });
        
        this.loaderService.display(false);
      })
  }

  getProcedureValidations(procedure_id){
    this.loaderService.display(true);
    this.validations=[]
    this.api.extra.getProcedureValidation(procedure_id).promise()
    .then(
      result => {
        
        
        this.validations = result
        this.loaderService.display(false);
      })
      .catch(e =>{
        this.messageService.add({
          severity: 'error',
          summary: 'Resultado',
          life: 4000,
          detail: `Error al buscar la lista de validaciones. ${e.message.error}`
        });
        
        this.loaderService.display(false);
      })
  }

  getAdjustment(current_processId){
    this.api.extra.getAdjustment(current_processId).promise()
    .then(
      result=>{
        this.countConsults =0;
        this.countPhisiotherapy=0;
        this.adjustment_list = result
        
        for(let adjust of this.adjustment_list){
          if (adjust.deleted !=1){
            if(adjust.concept == "medical_consultation"){
              this.countConsults +=1
            }
            if(adjust.concept == "phisiotherapy"){
              this.countPhisiotherapy+=1
            }
          }
        }
        this.tableOfTotals()
        this.$shared_adjustment_list.emit(this.adjustment_list);
        
        
        return true
      }
    )
  }
  deleteAdjustment(adjustment){
    this.api.extra.deleteAdjustment(adjustment).promise()
    .then(
      result =>{
        
        this.adjustment_list=[]
        this.getAdjustment(result.current_processId)
        this.messageService.add({
          severity: 'info',
          summary: 'Resultado',
          life: 4000,
          detail: "Eliminado correctamente"
        });
      }
    ).catch(e =>{
      this.messageService.add({
        severity: 'error',
        summary: 'Resultado',
        life: 4000,
        detail: `Error al eliminar ajuste. ${e.message.error}`
      });
      
    })
  }
  getListOfAdjustments(){
    
    return this.adjustment_list
  }
  tableOfTotals(){
    this.total_presented = 0;
    this.total_not_authorized=0;
    this.total_deductible=0;
    this.total_coinsurance=0;
    for(let adjust of this.adjustment_list){
      if (adjust.deleted != 1){
        this.total_presented += adjust.total_amount;
        if(adjust.proceed==0){
          this.total_not_authorized += adjust.total_amount;
        }
        else{
        this.total_deductible+= adjust.deductible;
        this.total_coinsurance+=adjust.coinsurance
        }
      }
    }
    
  }
  createDictum(dictum){
    // dictum.ibanAccount = dictum.ibanAccount.toString()
    
    
    this.api.extra.createDictum(dictum).promise()
    .then(
      result =>{
        this.dictum.push(result);
        
        
        this.dictum.push(result)
        this.messageService.add({
          severity: 'info',
          summary: 'Resultado',
          life: 4000,
          detail: "Dictamen creado satisfactoriamente"
        });
        let dataSend:any={
          "email": this.email,
          "subject": "Aprobación de dictámen",
          "body": "",
          "step": 5,
          "doc_id":result.documentId,
          "phone":"+502"+"",
          "claim_number": this.shared_info.claim.claim_number,
          "current_processId" : this.shared_info.currentProcess.current_processId
        }
    
        this.api.mailsender.sendguide(dataSend).promise().
        then(res=>{
          
          this.messageService.add({
            severity: 'info',
            summary: 'Resultado',
            life: 4000,
            detail: "Mensaje enviado"
          });
        },err=>{
          
          this.messageService.add({
            severity: 'error',
            summary: 'Resultado',
            life: 4000,
            detail: `Mensaje no enviado. ${err.message.error}`
          });
        }
        )
        // prueba 
        this.setDictumInfo(result.current_processId)
        this.after_add_dictum_docs = true
        let req ={"code":this.shared_info.coverage.code, "current_processId":this.shared_info.currentProcess.current_processId
        }
        this.setDocumentsSpecfications(JSON.stringify(req))
        // this.$shared_dictum.emit(this.dictum[this.dictum.length-1])
      }
    ).catch(e =>{
      this.messageService.add({
        severity: 'error',
        summary: 'Resultado',
        life: 4000,
        detail: `Error al agregar dictamen. ${e.message.error}`
      });
      
    })
  }

  CreateAdditionalDocsDictum(dictum,htmlpart){
    this.api.extra.createDictum(dictum).promise()
    .then(res=>{
      
      this.messageService.add({
        severity: 'info',
        summary: 'Resultado',
        life: 4000,
        detail: "Dictamen creado satisfactoriamente"
      });
        let dataSend:any={
          "email": this.email,
          "subject": "Solicitud de documentos adicionales",
          "body": "",
          "htmlpart":htmlpart,
          "step": 32,
          "name": this.shared_info.customer[0].formalName,
          "doc_id":res.documentId,
          "phone":"+502"+"",
          "claim_number": this.shared_info.claim.claim_number,
          "current_processId" : this.shared_info.currentProcess.current_processId
        }
        
        this.dictum.push(res)
        this.api.mailsender.sendguide(dataSend).promise().
        then(res=>{
          
          this.messageService.add({
            severity: 'info',
            summary: 'Resultado',
            life: 4000,
            detail: "Mensaje enviado"
          });
        },err=>{
           
          this.messageService.add({
            severity: 'error',
            summary: 'Resultado',
            life: 4000,
            detail: `Mensaje no enviado. ${err.message.error}`
          });
        }
        )
        // PRUEBA
        this.setDictumInfo(res.current_processId)
        this.after_add_dictum_docs = true
        let req ={"code":this.shared_info.coverage.code, "current_processId":this.shared_info.currentProcess.current_processId
        }
        this.setDocumentsSpecfications(JSON.stringify(req))

    }).catch(e=>{
      this.messageService.add({
        severity: 'error',
        summary: 'Resultado',
        life: 4000,
        detail: `Error al agregar dictamen. ${e.message.error}`
      });
      
    })
  }
  updateClaim(claim){
    
    this.api.claim.updateAmountClaim(claim).promise()
    .then(
      result =>{
        
      }
    ).catch(e =>{
      this.messageService.add({
        severity: 'error',
        summary: 'Resultado',
        life: 4000,
        detail: `Error al actualizar el reclamo. ${e.message.error}`
      });
      
    })
  }
  addReceptionDate(info){
    this.api.extra.addReceptionDate(info).promise()
    .then(
      result =>{
        
      }
    ).catch(e =>{
      this.messageService.add({
        severity: 'error',
        summary: 'Resultado',
        life: 4000,
        detail: `Error al agregar la fecha de recepción. ${e.message.error}`
      });
      
    })
  }
  getPossibleClaims(data){
    this.possible_claims = []
    this.creation_blocked =false
    
    this.api.claim.getClaimByPolicy(data).promise()
    .then( 
      result =>{
      
      
      for(let claim of result){
        if(claim.coverage.code == "0011" && claim.claim.claim_status =="ACTIVE"){
          this.creation_blocked = true
          
          this.possible_claims = result;
          return result
        }else
        {
          this.creation_blocked =false
        }
        let count = 0
        for(let dict of claim.dictum){
          if (dict == null){
            
            claim.dictum.splice(count,1)
          }
          count +=1
        }
      }
      
      this.possible_claims = result;
      return result
    }
    ).catch(e =>{
      
  })
  }
  getDocumentsSpecfications(){
    
    return this.document_specifications
  }
  setPolicyInfo(data){
    this.shared_policy = data;
    
  }
  getPolicyInfo(){
    return this.shared_policy;
  }
  setPhisioAdjust(data){
    this.phisioAdjust = data
    
  }
  getPhisioAdjust(){
    return this.phisioAdjust
  }

  setClaimInfo(data){
    this.shared_claim = data;
    
  }
  getClaimInfo(){
    return this.shared_claim;
  }
  setGlobalInfo(data){
    this.shared_info = data;
    
  }
  setGlobalListInfo(data){
    this.shared_list_info = data;
    
  }
  getGlobalInfo(){
    return this.shared_info;
  }
  getGlobalListInfo(){
    return this.shared_list_info;
  }
  getPreviewInfo(){
    return this.globalPreviewInfo
  }
  setDocCatalog(data){
    this.shared_doc_catalog = data;
  }
  getDocCatalog(){
    return this.shared_doc_catalog;
  }
  setCreateInfo(data){
    this.createInfoINS = data;
  }
  getCreateInfo(){
    return this.createInfoINS;
  }
  setDataSeats(data){
    this.dataSeat=data;
  }
  getDataSeat(){
    return this.dataSeat;
  }
  setBucaProcedures(procedures){
    this.bucaProcedures = procedures
  }
  getBucaProcedures(){
    return this.bucaProcedures
  }
  setBucaCategories(categories){
    this.bucaCategories = categories
  }
  getBucaCategories(){
    return this.bucaCategories
  }
  getMedicalHistory(){
    return this.medicalHistory;
  }

  setMedicalHistory(medicalHistory){
    this.medicalHistory = medicalHistory;
  }

  setMedicalHistoryQuestions(questions){
    this.questionsMedicalHistory = questions
  }
  setSenha(senha){
    this.senhaResponse = senha
  }
  getSenha(){
    return this.senhaResponse
  }
  setPlanServiceData(planService){
    this.planServiceData = planService
  }
  getPlanServiceData(){
    return this.planServiceData
  }
  setHistoryKidsAmount(historyKids){
    this.historyKidsAmount = historyKids
  }
  setHistoryHolderAndSpouseAmount(historyHolderSpouse){
    this.historyHolderAndSpouseAmount = historyHolderSpouse
  }
  setCurrencyExchange(currency_exchange){
    this.currency_exchange = currency_exchange
    
    
  }
  getCurrrencyExchange(){
    return this.currency_exchange
  }

  setDictumInfo(data){
    
    
    
    // if(!this.dictum){
    this.api.extra.getDictum(data).promise()
    .then(
      result=>{
        
        
        
        this.dictum = result.dictum;
        if(result.additional_document){
          this.additional_document = result.additional_document;
          
        }
        // this.$shared_dictum.emit(this.dictum[this.dictum.length-1])
        
      }
    ).catch(e =>{
      
      
    })
  // }
  }
  getDictumInfo(){
    return this.dictum;
  }
  countRequired(object){
    this.count_required = 0
    for(let required of object){
      if (required.insured_document == 0 || required.insured_document == 1){
        if(required.required == 1){
          this.count_required += 1
        }
      }
    }
  }
  getRequiredCount(){
    return this.count_required;
  }
  getTooltips(){
    this.tooltips={}
    this.api.extra.getTooltips().promise()
    .then(
      result=>{
        
        this.tooltips= result;

      }).catch(e =>{
          
          
    })
  }
  addTooltip(tooltip){
    this.api.extra.addTooltip(tooltip).promise()
    .then(
      result=>{
        this.messageService.add({
          severity: 'info',
          summary: 'Resultado',
          life: 4000,
          detail: "Tooltip creado con éxito"
        });
        this.$tooltip.emit(result)
      }).catch(e =>{
        
        this.messageService.add({
          severity: 'error',
          summary: 'Resultado',
          life: 4000,
          detail: `Creación de tooltip fallida. ${e.message.error}message.error}`
        });
        
  })
  }
  verifyRejectionSvc(documents){
    this.client_count=0
    this.campus_count=0
    this.validations_list=[]
    this.validation_list_client=[]
    for(let doc of documents){
      if(doc.document_statusId==4){
        this.api.extra.getValidation(doc.documentationId).promise()
    .then(
      result => {
        
        for(let res of result){
          res["document_name"]=doc.document_name
          res["document_catalogId"]=doc.document_catalogId
          if(res.rejected_to==0){
            this.client_count +=1
            this.validation_list_client.push(res);
          }
          else if(res.rejected_to==1){
            this.campus_count +=1
            this.validations_list.push(res);
          }
        }
        
      })
      .catch(e =>{
        this.messageService.add({
          severity: 'error',
          summary: 'Resultado',
          life: 4000,
          detail: `Error al buscar la lista de validaciones. ${e.message.error}`
        });
        
      })
      }
    }
  }
  setCalls(current){
    this.api.extra.setCalls(current).promise()
      .then(
      result => {
        this.attendedCounter = 0
        
        for(let call of result){
          if(call.attended != 1){
            
            this.attendedCounter +=1
          }
        }
        // this.$result.subscribe()
        this.totalCalls = result
      })
      .catch(e =>{
        this.messageService.add({
          severity: 'error',
          summary: 'Resultado',
          life: 4000,
          detail: "Error al obtener las llamadas"
        });
        
      })
  }
  getCalls(){
    return this.totalCalls
  }
  clearCalls(current){
    this.api.extra.clearCalls(current).promise()
      .then(
      result => {
        
      })
      .catch(e =>{
        this.messageService.add({
          severity: 'error',
          summary: 'Resultado',
          life: 4000,
          detail: "Error al actualizar las llamadas previas"
        });
        
      })
  }
  addCall(call){
    this.api.extra.addCall(call).promise()
    .then(
      res =>{
        
        this.attendedCounter = 0
        this.result = res
        this.messageService.add({
          severity: 'info',
          summary: 'Resultado',
          life: 4000,
          detail: "Llamada registrada correctamente"
        });
        // this.setCalls(this.shared_info.currentProcess)
        this.totalCalls.push(res)
        for(let call of this.totalCalls){
          if(call.attended != 1){
            
            this.attendedCounter +=1
          }
        }
        this.$result.emit(this.result)
        return res;
      }
    ).catch(e =>{
      this.messageService.add({
        severity: 'error',
        summary: 'Resultado',
        life: 4000,
        detail: "Error al agregar la llamada"
      });
      
    })
  }
  
  changeClaimStatus(data){
    this.api.claim.changeClaimStatus(data).promise()
    .then(
      res =>{
        
        this.shared_info.claim = res
        this.$updateclaim.emit(this.shared_info);
        
      }
      ).catch(e =>{
        this.messageService.add({
          severity: 'error',
          summary: 'Resultado',
          life: 4000,
          detail: "Error al agreegar el comentario"
        });
        
      })
  }
  createNewProcess(claim){
    
    this.api.extra.subsecuentProcess(claim).promise()
    .then(
      res =>{
        
        
        this.setGlobalInfo(res)
        this.$add_subsecuent.emit(res)
        return res
      }
      ).catch(e =>{
        this.messageService.add({
          severity: 'error',
          summary: 'Resultado',
          life: 4000,
          detail: "Error al agregar el procedimiento subsecuente"
        });
        
      })

  }
  async createTeethProcedure(procedure, personToAttend, iam){
    this.loaderService.display(true);
    
        let data = {}
        data['token'] = iam.token
        data['user'] = iam.id
        data['procedure'] = procedure
        data['customer'] = personToAttend
        
        if(this.shared_info.currentProcess.procedure_type == 'BUCA INSURANCE' && this.sumAssured == 0){
          const hadResponse = await this.getSumAssured();
          if(!hadResponse) return
        }
        
        this.api.extra.getEffectiveDateServiceEvents(data).promise()
          .then(response => {
            if(Object.keys(response['service_availability']).length === 0){
              this.loaderService.display(false);
              this.messageService.add({
                severity: 'error',
                summary: 'Resultado',
                life: 6000,
                detail: "No se pudo validar la disponibilidad del servicio"
              });
              return
            }
            
            if(personToAttend['relationToMI'] && response['service']['max_assistance_dependents'] == null){ // Dependent
              this.loaderService.display(false);
              this.messageService.add({
                severity: 'error',
                summary: 'Resultado',
                life: 6000,
                detail: `No existe configuración de 'Máximo de Eventos Para Dependientes' para este servicio del plan, con el cual validar si procede el evento.`
              });
              return;
            }

            let age = response['age']
            this.setPlanServiceData(response['service'])
            
            const currency_exchange = this.getCurrrencyExchange()
            const updatedHistoryHolderAndSpouseAmount = this.historyHolderAndSpouseAmount * currency_exchange.exchange_rate;
            const updatedHistoryKidsAmount = this.historyKidsAmount * currency_exchange.exchange_rate;
            const updatedProcedureInsuranceAmount = (procedure.insurance_amount + procedure.insurance_amount_iva) * currency_exchange.exchange_rate;
            
            if(this.planServiceData.maximum_age){
              if(!age) {
                this.loaderService.display(false);
                    this.messageService.add({
                      severity: 'error',
                      summary: 'Resultado',
                      life: 6000,
                      detail: "El procedimiento tiene una restricción por edad sin embargo el paciente no cuenta con registro de fecha de nacimiento para validar."
                    });
                  return
              }
              
              if(age > this.planServiceData.maximum_age){
                this.loaderService.display(false);
                this.messageService.add({
                  severity: 'error',
                  summary: 'Resultado',
                  life: 6000,
                  detail: "La edad del paciente (" + age + ") supera la edad máxima (" + this.planServiceData.maximum_age + ") para realizar este procedimiento."
                });
              return
              }
            }
            

            // VALIDACIÓN PARA CUANDO ES UN MAX AMOUNT POR SERVICIO
            let amountPass = false
            for(let rev of this.bucaProcedures){
              if(rev.procedure.sc_assistance_service_id == this.planServiceData.service_id){
                amountPass = true
                break
              }
            }
            if(amountPass){
              let compare_amount = 0
              for(let amount of this.bucaProcedures){
                if(amount.procedure.sc_assistance_service_id == this.planServiceData.service_id){
                  if(compare_amount == 0){
                    compare_amount += (amount.procedure.insurance_amount + amount.procedure.insurance_amount_iva) * 2  
                  }
                  else{
                    compare_amount += amount.procedure.insurance_amount + amount.procedure.insurance_amount_iva
                  }
                }
              }
              let compare = compare_amount * currency_exchange.exchange_rate
              if(compare > this.planServiceData.max_amount){
                let val = (compare - this.planServiceData.max_amount)/currency_exchange.exchange_rate
                val = Math.abs(val)
                this.loaderService.display(false);
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Resultado',
                    life: 6000,
                    detail: "Se ha excedido el monto maximo para este servicio por un monto de: ₡" + val.toFixed(2)
                  });
                return
              }
            }

            if(this.shared_info.currentProcess.procedure_type == 'BUCA INSURANCE'){
              if(personToAttend.relationToMI== null || personToAttend.relationToMI == "1"){
                // VALIDACION DE MAXIMOS
                if(this.sumAssured > (updatedHistoryHolderAndSpouseAmount + updatedHistoryKidsAmount + updatedProcedureInsuranceAmount) ){
                  
                }
                else{
                  
                  let val = this.sumAssured - (updatedHistoryHolderAndSpouseAmount + updatedHistoryKidsAmount + updatedProcedureInsuranceAmount)
                  val = Math.abs(val)
                  let relationship = personToAttend.relationToMI == null ? 'Titular' : 'Cónyuge'
                  this.loaderService.display(false);
                    this.messageService.add({
                      severity: 'error',
                      summary: 'Resultado',
                      life: 4000,
                      detail: "Se ha excedido el monto de la Suma Asegurada para el " + relationship + " por un monto de: ₡" + val.toFixed(2)
                    });
                  return
                }
              }
              else if(personToAttend.relationToMI == "2"){
                if((this.sumAssured / 2)> updatedHistoryHolderAndSpouseAmount){
                  if((this.sumAssured / 2 )> (updatedHistoryKidsAmount + updatedProcedureInsuranceAmount) ){
                    
                  }
                  else{
                    
                    let val = (this.sumAssured / 2) - (updatedHistoryKidsAmount + updatedProcedureInsuranceAmount)
                    val = Math.abs(val)
                    this.loaderService.display(false);
                    this.messageService.add({
                      severity: 'error',
                      summary: 'Resultado',
                      life: 4000,
                      detail: "Se ha excedido el monto de la Suma Asegurada para el Dependiente por un monto de: ₡" + val.toFixed(2)
                    });
                    return
                  }

                }
                else{
                  if((this.sumAssured) > updatedHistoryHolderAndSpouseAmount + updatedHistoryKidsAmount + updatedProcedureInsuranceAmount){
                    
                  }
                    else{
                      
                      let val = (this.sumAssured ) - (updatedHistoryHolderAndSpouseAmount + updatedHistoryKidsAmount + updatedProcedureInsuranceAmount)
                      val = Math.abs(val)
                      this.loaderService.display(false);
                      this.messageService.add({
                        severity: 'error',
                        summary: 'Resultado',
                        life: 4000,
                        detail: "Se ha excedido el monto de la Suma Asegurada para el Dependiente por un monto de: ₡" + val.toFixed(2)
                      });
                      return 
                  }
                }
              }
            }

            if(response.service_availability.on_waiting_period){
              this.loaderService.display(false);
              this.messageService.add({
                severity: 'warn',
                summary: 'Resultado',
                life: 4000,
                detail: `No se ha completado el tiempo de espera del procedimiento. Fecha a partir de la cual se puede asignar el procedimiento: ${response.service_availability.waiting_period_date}`
              });
            }
            else{
              if(response.service_availability.remaining_assistances > 0){
                
                this.api.extra.createTeethProcedure(procedure).promise()
                .then(
                  res =>{
                    if('result' in res){
                      this.loaderService.display(false);
                      this.messageService.add({
                        severity: 'warn',
                        summary: 'Resultado',
                        life: 3500,
                        detail: res['result']
                      });
                      return;
                    }
                    this.$add_teeth_procedure.emit(res)
                    this.loaderService.display(false);
                  }
                  ).catch(e =>{
                    this.loaderService.display(false);
                    this.messageService.add({
                      severity: 'error',
                      summary: 'Resultado',
                      life: 6000,
                      detail: `Error al agregar el procedimiento dental. ${e?.error?.error ? e.error.error : ""}`
                    });
                    
                  })
              }
              else{
                this.loaderService.display(false);
                let count = personToAttend['relationToMI'] == null ? response.service.max_assistance : response.service.max_assistance_dependents
                const message = count > 1 ? 'procedimientos asignados' : 'procedimiento asignado';
                                
                this.messageService.add({
                  severity: 'warn',
                  summary: 'Resultado',
                  life: 6000,
                  detail: `Se ha alcanzado el máximo de asistencias permitidas por período para el procedimiento requerido (${count} ${message}). \n Fecha para asignar nuevo evento: ${response.service_availability.to_date}`
                });
              }
            }
          })
          .catch(e =>{
            this.loaderService.display(false);
            this.messageService.add({
              severity: 'error',
              summary: 'Resultado',
              life: 6000,
              detail: `Error en las validaciones del procedimiento. ${e.message.error}`
            });
            
          })
  }

  getSumAssured():Promise<boolean>{
    return new Promise((resolve, reject) => {
      this.api.policy.get(this.shared_info.policy.policyNum).promise()
        .then(resp => {
          if('status' in resp && resp['status'] == 200){
            for(let customer of resp['data']['policy']['customers']){
              let customer_products = customer['customerProducts']
              if(customer_products.length == 1){
                for(let benefit of customer_products[0]['scheduleBenefits']){
                  if(benefit['benefitAmount'] > this.sumAssured) this.sumAssured = benefit['benefitAmount'];
                }
                resolve(true);
              } else {
                customer_products.forEach(customer_product => {
                  this.api.policy.getEquivalence({value:customer_product['productCode']}).promise()
                    .then(rsp => {
                      if (rsp != null) {
                        for(let benefit of customer_product['scheduleBenefits']){
                          if(benefit['benefitAmount'] > this.sumAssured) this.sumAssured = benefit['benefitAmount'];
                        }
                        resolve(true);
                      } 
                    })
                });
              }
            }
          }
        },
        err=>{
          this.loaderService.display(false);
          this.messageService.add({
            severity: 'error',
            summary: 'Resultado',
            life: 4000,
            detail: "No se pudo obtener los datos de la Suma Asegurada, intente más tarde."
          });
          reject(false)
        })
        .catch(e => {
          this.loaderService.display(false);
          this.messageService.add({
            severity: 'error',
            summary: 'Resultado',
            life: 4000,
            detail: "No se pudo obtener los datos de la Suma Asegurada, intente más tarde."
          });
          reject(false);
        })
    })
  }

  sendToothProcedures(procedureList, data, user){
    
    let temp = {}
    temp["procedures"]=procedureList
    temp["data"]=data
    temp["user"]=user
    
    this.api.extra.sendToothProcedures(temp).promise()
    .then(
      res =>{
        
        // 
      }
      ).catch(e =>{
        this.messageService.add({
          severity: 'error',
          summary: 'Resultado',
          life: 4000,
          detail: `No se pudo agregar el procedimiento dental. ${e.message.error}`
        });
        
      })
  }

  createBucaSinister(data,claim,user_id, client) {
    this.medicalHistory = {}
    this.bucaProcedures = []
    let global_info = {policy: data, claim:claim, user_id:parseInt(user_id)}
    
    this.api.buca.createBucaSinister(global_info).promise()
      .then(
          global_info => {
            this.shared_info = global_info
              
              
              this.messageService.add({
                severity: 'info',
                summary: 'Resultado',
                life: 4000,
                detail: "Evento creado con exito"
              });
              this.setGlobalInfo(global_info);
              this.api.buca.getMedicalHistory(client).promise()
              .then(
                res =>{
                  this.medicalHistory = res
                  // Se abre directamente el odontograma, se salta la historia médica
                  this.openBucaClaim(this.shared_info, global_info.claim.claim_number)
                })
          }).catch( e=>{
              
              
              
              this.messageService.add({
                severity: 'error',
                summary: 'Resultado',
                life: 4000,
                detail: `Evento no fue creado. ${e.message.error}`
              });
          }
      );
    }
    startBucaProcedure(data, client) {
      this.medicalHistory = []
      this.bucaProcedures = []
      

      this.loaderService.display(true);
      this.api.buca.startBucaProcedure(data).promise()
        .then(
            global_info => {
              this.shared_info = global_info
                
                
                this.messageService.add({
                  severity: 'info',
                  summary: 'Resultado',
                  life: 4000,
                  detail: "Evento creado con exito"
                });
                this.setGlobalInfo(global_info);
                this.api.buca.getMedicalHistory(client).promise()
                .then(
                  res =>{
                    this.medicalHistory = res
                    this.loaderService.display(false);
                    
                    // Se abre directamente el odontograma, se salta la historia médica
                    this.openBucaClaim(this.shared_info, global_info.claim.claim_number)
                  })
            }).catch( e=>{
                
                
                
                this.messageService.add({
                  severity: 'error',
                  summary: 'Resultado',
                  life: 4000,
                  detail: `Evento no fue creado. ${e.message.error}`
                });
                this.loaderService.display(false);
            }
        );
      }

  openBucaMedicalHistory(global_info) {
    
    this._router.navigate(['admin/buca-medical-history'])     
    } 

  openBucaClaim(global_info, claimId) {
    
    this._router.navigate([`admin/odontogram/${claimId}`])     
    }  

  createMedicalHistory(answer, claimId){
    this.loaderService.display(true);
    this.api.buca.createMedicalHistory(answer).promise()
      .then(data => {
        this.medicalHistory = data;
        this.loaderService.display(false);
        this._router.navigate([`admin/odontogram/${claimId}`]);
      })
  }

  getFullMedicalHistoryView(personalId){
    this.api.buca.getMedicalHistory(personalId).promise()
    .then(
      data => {
      this.loaderService.display(false);
      this.medicalHistory = data
      this._router.navigate(['admin/history-events'])
      })
  }

  getPatientHistory(search){
    this.api.buca.getPatientHistory(search).promise()
    .then(
      data => {
        
        this.dataSourcePatientHistory = new MatTableDataSource<any>(data);
      })
      .catch( e=>{
        
        
        this.messageService.add({
          severity: 'error',
          summary: 'Resultado',
          life: 4000,
          detail: `No se encontraron resultados. ${e.message.error}`
        });
    }
  );
  }

  downloadPdf(data){
    this.loaderService.display(true)

    const headers = new HttpHeaders({
      "Authorization": `Bearer ${this.me.token}`,
      'Content-Type': 'application/json'
    })

    const options = { headers,responseType: 'blob' as 'json'}

    this.http.post('/api/buca/download/confirmationletter', data, options)
    .pipe(
      catchError(error => {
        this.loaderService.display(false);
        this.messageService.add({
          severity: 'error',
          summary: 'Resultado',
          life: 4000,
          detail: `Error al cargar el documento.`
        });
        return throwError(error);
      })
    )
    .subscribe((response:any) => {
      this.loaderService.display(false);
      if("code" in response){
        this.messageService.add({
          severity: 'error',
          summary: 'Resultado',
          life: 4000,
          detail: `Error al cargar el documento.`
        });
      }

      // Create a Blob URL for the PDF response
      const blobUrl = URL.createObjectURL(response);

      // Create an anchor element for downloading
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = 'Carta de confirmacion'; // Specify the desired file name

      // Programmatically trigger the download
      a.click();

      // Clean up the Blob URL
      URL.revokeObjectURL(blobUrl);
    });
  }

}